// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3CnVJ","icon":"SortAdornment_icon__3eyDZ","up":"SortAdornment_up__3bLIY","down":"SortAdornment_down__2uh9N","active":"SortAdornment_active__3kY0H"};